
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Improved error handling with more detailed logging
const handleError = (error: Error, info?: string) => {
  console.error(`Application error${info ? ` (${info})` : ''}:`, error);
  
  // Only redirect if the error is critical and we're not on the home page
  if (window.location.pathname !== '/' && window.location.pathname !== '/index.html') {
    console.log('Redirecting to home page due to error');
    window.location.href = '/';
  }
};

// Set up more robust global error handlers
window.addEventListener('error', (event) => {
  handleError(event.error, 'window.error');
  event.preventDefault();
});

window.addEventListener('unhandledrejection', (event) => {
  handleError(event.reason, 'unhandledrejection');
  event.preventDefault();
});

// Create root and handle rendering errors
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('Root element not found');
  document.body.innerHTML = '<div style="padding: 20px; text-align: center;"><h1>Error loading application</h1><p>Please try refreshing the page.</p></div>';
} else {
  const root = createRoot(rootElement);

  try {
    console.log('Rendering application...');
    root.render(<App />);
  } catch (error) {
    handleError(error as Error, 'render');
    // Fallback rendering with basic error message
    root.render(
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center p-8 bg-white rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
          <p className="mb-4">We're sorry for the inconvenience. Please try refreshing the page.</p>
          <button 
            onClick={() => window.location.href = '/'} 
            className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }
}
